import { Images } from '../../PackagingDispute/Images'

const ImagesList = ({ images }) => {
  return <Images pictureModels={images} />
}

export default ImagesList
